import './App.css';
import Homepage from './pages/Homepage'

function App() {
  return (
    <div className="app theme-2">
     <Homepage />
    </div>
  );
}

export default App;
